import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select
} from "antd";
import _ from "lodash";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import { routes } from "../../../routes";
import Heading from "../../../components/common/heading";
import WithSidebar from "../../../templates/withSidebar";
import SuccessModal from "../../../components/modal/successModal";
import FailModal from "../../../components/modal/failModal";
import TableNameList from "./components/table";
import {
  getListIndicatorByYear,
  updateIndicatorByYear,
  // getListProjectByYear,
  getListDepartments,
  getListDivisions,
  getProjectByYearlyProject
} from "../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../lib/const";

const { useToken } = theme;
const { Option } = Select;

export const EditKPI = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const params = useParams();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [data, setData] = useState({});
  const [listProject, setListProject] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  //TABLE FUNCTION
  const [dataSource, setDataSource] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [tableAction, settableAction] = useState(false);
  const [statusBT, setStatusBT] = useState(false);

  const convertDataList = async (dataList) => {
    const result = dataList.reduce((acc, item) => {
      const {
        yearOfBudget,
        projectId,
        projectNameEn,
        projectNameTh,
        indicatorId,
        indicatorNameEn,
        indicatorNameTh,
        departmentId,
        departmentNameEn,
        departmentNameTh,
        divisionId,
        divisionNameEn,
        divisionNameTh,
        id
      } = item;
      const yearIndex = acc.findIndex((x) => x.yearOfBudget === yearOfBudget);
      if (yearIndex === -1) {
        let object = {
          yearOfBudget,
          indicators: [
            {
              id,
              indicatorId,
              indicatorNameEn,
              indicatorNameTh,
              departmentId,
              divisionId,
              projects: [
                {
                  projectId,
                  projectNameEn,
                  projectNameTh,
                  departmentId,
                  departmentNameEn,
                  departmentNameTh,
                  divisionId,
                  divisionNameEn,
                  divisionNameTh
                }
              ]
            }
          ]
        };

        // form.setFieldsValue(object);
        acc.push(object);
      } else {
        const indicatorIndex = acc[yearIndex].indicators.findIndex(
          (x) => x.indicatorId === indicatorId
        );
        if (indicatorIndex === -1) {
          let object = {
            id,
            indicatorId,
            indicatorNameEn,
            indicatorNameTh,
            departmentId,
            divisionId,
            projects: [
              {
                projectId,
                projectNameEn,
                projectNameTh,
                departmentId,
                departmentNameEn,
                departmentNameTh,
                divisionId,
                divisionNameEn,
                divisionNameTh
              }
            ]
          };
          // form.setFieldsValue(object);
          acc[yearIndex].indicators.push(object);
        } else {
          let object = {
            projectId,
            projectNameEn,
            projectNameTh,
            departmentId,
            departmentNameEn,
            departmentNameTh,
            divisionId,
            divisionNameEn,
            divisionNameTh
          };
          acc[yearIndex].indicators[indicatorIndex].projects.push(object);
        }
      }
      return acc;
    }, []);

    return result;
  };

  const handleChange = (value, key) => {
    setDepartmentId(value);
    setListProject([]);
    form.setFields([
      {
        name: "divisionId",
        value: undefined
      }
    ]);
  };

  const fetchIndicatorById = useCallback(
    async (id) => {
      // call project api by year and id
      const res = await getListIndicatorByYear({
        year: params.year,
        indicatorId: params.id
      });
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        const convert = await convertDataList(objectValue);
        let addKey = convert[0].indicators[0].projects.map((x, i) => ({
          ...x,
          key: i,
          projectAction: "NONE"
        }));
        setData(convert[0]);
        setDataSource(addKey);
        setTableList(addKey);
        setDepartmentId(convert[0]?.indicators[0].departmentId);

        form.setFieldsValue({
          id: convert[0]?.indicators[0].id,
          yearOfBudget: convert[0]?.yearOfBudget,
          indicatorId: convert[0]?.indicators[0].indicatorId,
          indicatorNameEn: convert[0]?.indicators[0].indicatorNameEn,
          indicatorNameTh: convert[0]?.indicators[0].indicatorNameTh,
          departmentId: convert[0]?.indicators[0].departmentId,
          divisionId: convert[0]?.indicators[0].divisionId
        });
      }
    },
    [setData]
  );

  // const fetchListProjectByYear = useCallback(async () => {
  //   try {
  //     const res = await getListProjectByYear({
  //       year: params.year,
  //       projectId: "",
  //     });

  //     if (res.data.code === SUCCESS_CODE) {
  //       let result_data = res.data.objectValue;
  //       setListProject(result_data);
  //     }
  //   } catch (error) {}
  // }, [listProject]);

  // useEffect(() => {
  //   fetchListProjectByYear();
  // }, []);

  const fetchProjectByYearlyPlan = async () => {
    const request = {
      departmentId: form.getFieldValue().departmentId
        ? form.getFieldValue().departmentId
        : "",
      divisionId: form.getFieldValue().divisionId
        ? form.getFieldValue().divisionId
        : "",
      yearOfBudget: params.year
    };

    const res = await getProjectByYearlyProject(request);
    if (res.data.code === SUCCESS_CODE) {
      let result_data = res.data.objectValue;
      setListProject(result_data);
    }
  };

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  useEffect(() => {
    fetchProjectByYearlyPlan();
  }, [departmentId, divisionId, params.year]);

  const handleAdd = () => {
    const newDataSource = {
      key: Number(tableList.length),
      departmentId: "",
      departmentNameEn: "",
      departmentNameTh: "",
      divisionId: "",
      divisionNameEn: "",
      divisionNameTh: "",
      projectId: "",
      projectNameEn: "",
      projectNameTh: "",
      projectAction: "ADD"
    };

    setDataSource((prevDataSource) => [...prevDataSource, newDataSource]);
    setTableList((prevTableList) => [...prevTableList, newDataSource]);
  };

  const handleEdit = (value, index, key) => {
    const findData = listProject.find((v) => v.projectId === value);

    setTableList((prevTableList) =>
      prevTableList.map(
        (project) =>
          project.key === index
            ? {
                ...project,
                ...{
                  key: project.key,
                  // [key]: value,
                  divisionId: _.get(findData, "divisionId"),
                  divisionNameEn: _.get(findData, "divisionNameEn"),
                  divisionNameTh: _.get(findData, "divisionNameTh"),
                  projectId: _.get(findData, "projectId"),
                  projectNameEn: _.get(findData, "projectNameEn"),
                  projectNameTh: _.get(findData, "projectNameTh"),
                  departmentId: _.get(findData, "departmentId"),
                  departmentNameEn: _.get(findData, "departmentNameEn"),
                  departmentNameTh: _.get(findData, "departmentNameTh"),
                  projectAction: _.isEmpty(project.projectAction)
                    ? "ADD"
                    : project.projectAction
                }
              }
            : {
                ...project,
                ...{
                  projectAction: _.isEmpty(project.projectAction)
                    ? "NONE"
                    : project.projectAction
                }
              } // Leave other projects unchanged
      )
    );

    setDataSource((prevDataSource) =>
      prevDataSource.map(
        (project) =>
          project.key === index
            ? {
                ...project,
                ...{
                  key: project.key,
                  // [key]: value,
                  divisionId: _.get(findData, "divisionId"),
                  divisionNameEn: _.get(findData, "divisionNameEn"),
                  divisionNameTh: _.get(findData, "divisionNameTh"),
                  projectId: _.get(findData, "projectId"),
                  projectNameEn: _.get(findData, "projectNameEn"),
                  projectNameTh: _.get(findData, "projectNameTh"),
                  departmentId: _.get(findData, "departmentId"),
                  departmentNameEn: _.get(findData, "departmentNameEn"),
                  departmentNameTh: _.get(findData, "departmentNameTh"),
                  projectAction: _.isEmpty(project.projectAction)
                    ? "ADD"
                    : project.projectAction
                }
              }
            : {
                ...project,
                ...{
                  projectAction: _.isEmpty(project.projectAction)
                    ? "NONE"
                    : project.projectAction
                }
              } // Leave other projects unchanged
      )
    );
  };

  const onSaveTable = async (values) => {};

  const handleDeleteReccord = (record) => {
    setDataSource((pre) => {
      return pre.filter((table) => table.key != record.key);
    });

    setTableList((prevDataSource) =>
      prevDataSource.map((project) =>
        project.key === record.key
          ? {
              ...project,
              ...{
                projectAction: "REMOVE"
              }
            } // Update the object with the new data
          : {
              ...project,
              ...{
                projectAction: _.isEmpty(project.projectAction)
                  ? "NONE"
                  : project.projectAction
              }
            }
      )
    );
  };

  const onFinish = async (values) => {
    if (dataSource.length > 0) {
      const findDataSource = _.compact(
        tableList.map((v) => {
          if (v.projectAction === "REMOVE" && _.isEmpty(v.departmentId)) return;

          return {
            projectId: v.projectId,
            projectAction: v.projectAction ? v.projectAction : "NONE"
          };
        })
      );

      const hasDuplicates = findDataSource
        .map((item) => item.projectId)
        .some((id, index, arr) => arr.indexOf(id) !== index);

      if (hasDuplicates) {
        setFailModal(true);
        setErrorMessage("ไม่สามารถเลือกโครงการที่ซ้ำกันได้");
      } else {
        const request = {
          yearOfBudget: params.year,
          data: [
            {
              indicatorId: form.getFieldValue().indicatorId,
              indicatorNameEn: form.getFieldValue().indicatorNameEn,
              indicatorNameTh: form.getFieldValue().indicatorNameTh,
              departmentId: form.getFieldValue().departmentId,
              divisionId: form.getFieldValue().divisionId,
              indicationAction: form.getFieldValue().indicationAction
                ? form.getFieldValue().indicationAction
                : "NONE", // CREATE, UPDATE, DELETE, NONE
              projects: findDataSource
            }
          ]
        };

        const res = await updateIndicatorByYear(request);
        let errorMessage = _.get(
          res.data.objectValue,
          "indicators[0].errorMessage"
        );

        const duplicateProject = _.find(
          _.get(res.data.objectValue, "indicators[0].projects"),
          function (n) {
            if (n.errorMessage !== null) {
              return true;
            }
          }
        );

        if (res.data.code === SUCCESS_CODE) {
          if (errorMessage) {
            if (errorMessage === "Data duplicate.") {
              setFailModal(true);
              setErrorMessage("ตัวชี้วัดดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
            } else {
              setErrorMessage("");
              setFailModal(true);
              setTimeout(() => {
                setFailModal(false);
              }, 2000);
            }
          } else {
            if (duplicateProject) {
              setFailModal(true);
              setErrorMessage("ไม่สามารถเลือกโครงการที่ซ้ำกันได้");
            } else {
              setSuccessModal(true);
              setTimeout(() => {
                navigate(routes.progress_tab_kpi);
                setSuccessModal(false);
              }, 2000);
            }
          }
        } else {
          setErrorMessage("");
          setFailModal(true);
          setTimeout(() => {
            setFailModal(false);
          }, 2000);
        }
      }
    } else {
      setFailModal(true);
      setErrorMessage("กรุณาเพิ่มโครงการอย่างน้อย 1 โครงการ");
    }
  };

  useEffect(() => {
    fetchIndicatorById(params.id);
  }, [params.id, fetchIndicatorById]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_kpi);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading
                  text={"แก้ไขตัวชี้วัด"}
                  size={4}
                  style={{ margin: 0 }}
                />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "ตัวชี้วัด"
                },
                {
                  title: "รายละเอียด"
                },
                {
                  title: <span className="pr_green">แก้ไขตัวชี้วัด</span>
                }
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_kpi);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={`ปีงบประมาณ${" " + params.year}`}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={16} style={{ marginBottom: "12px" }}>
                  <Form.Item
                    label="ชื่อตัวชี้วัด"
                    name={"indicatorNameTh"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                    onChange={(e) => {
                      form.setFields([
                        {
                          name: "indicationAction",
                          value: "UPDATE"
                        }
                      ]);
                    }}
                  >
                    <Input placeholder="กรุณากรอกช้อมูล" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((option) => (
                        <Option value={option.departmentId}>
                          {option.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12} className="gutter-row">
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(e) => {
                        setListProject([]);
                        setDivisionId(e);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <TableNameList
                    dataSource={dataSource}
                    editingRow={editingRow}
                    canEdit={true}
                    canView={false}
                    handleAdd={handleAdd}
                    handleEdit={handleEdit}
                    onSaveTable={onSaveTable}
                    handleDeleteReccord={handleDeleteReccord}
                    statusBT={statusBT}
                    tableAction={tableAction}
                    year={params.year}
                    listProject={listProject}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={errorMessage ? "กรุณาทำการตรวจสอบข้อมูล" : ""}
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
